import {translation} from "@2d-front-monorepo/core";
import {Permits, PermitStatusType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {ReactNode} from "react";
import {Link} from "react-router";
import {formatRoute, PrivateRoutes} from "../../../routes";
import {ArchivedPermitMenuProps} from "../../Registrations";

/**
 * Unlike {@link DefaultPermitMenu}, this one is empty by default: renewal is the only entry it
 * knows about and every tenant has to opt in. The card drops the whole popover for an empty menu.
 *
 * Entries live in an array, so each one needs its own `key`.
 */
export default function DefaultArchivedPermitMenu({permit, renewEnabled}: ArchivedPermitMenuProps): ReactNode[] {
	const entries: ReactNode[] = [];

	if (renewEnabled && permit.status.type === PermitStatusType.Expired && !Permits.alreadyRenewed(permit)) {
		entries.push(
			<Link key="renew" to={formatRoute(PrivateRoutes.permitsRenew, permit.id)}>
				{translation(PermitTranslations.permit_page__renew__button)}
			</Link>);
	}

	return entries;
}
